/**
 * main.jsx -- Equivalente a src/js/main.js del proyecto vanilla (el
 * archivo que arranca todo). Ahi main.js llama a tryResumeSession() y
 * decide login vs shell; aqui App.jsx hace exactamente lo mismo dentro
 * de un useEffect (ver ese archivo, useBootstrap()) -- main.jsx solo
 * monta el arbol de React, ninguna logica de bootstrap vive aqui.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
